(function($) {
	'use strict';

	$.search = function(el) {
		var $win = $(window);
		var minimumSearchCharacters = 1;
		var $search,
			searchUrl,
			newDashboardLayout = false,
			$input,
			$locationInput,
			$resultsContainer = null,
			$items = null,
			$trigger = null,
			currActive = -1,

			init = function(element) {

				$search = $(element);
				$input = $search.find('input.merchant-search');
				$locationInput = $search.find('input.pp-data-browser-location');

				var mobileMQ = '(max-width: 700px)';
				var isMob = window.matchMedia(mobileMQ);

				var pauseTime = 300,
					pauseTimeout = null;

				// SHIFT + A keyboard shortcut to show nav
				$win.on('keyup', function(e) {
					if (e.which === 83 && e.shiftKey) {
						$input.focus();
					}
				});

				// Set placeholder for search field
				if (!isMob) {
					$input = $($input[1]);
					$input.attr('placeholder', 'Search for an organization (SHIFT + S)');
				}


				// Setup variables
				$resultsContainer = $search.find('.results');
				$trigger = $($search.data('trigger'));
				searchUrl = $search.data('search-url');

				// feature flag
				newDashboardLayout = $search.data('new-dashboard');

				// Handle triggering of mobile search icon
				if (isMob) {

					if ($trigger) {
						$trigger.on('click', function() {
							var $mobSearch = $('.mobile-search .org-search');
							$('body').trigger('searchActivated', {});
							if ($mobSearch.hasClass('onscreen')) {
								$mobSearch.removeClass('onscreen');
								$(this).removeClass('active');
							} else {
								$mobSearch.addClass('onscreen');
								$(this).addClass('active');
								$input.focus();
							}

							return false;
						});
					}

					$('body').trigger('searchActivated', {});
				}

				// Handle input on search field
				$search
					.on('keyup', 'input', function(e) {

						if (e.keyCode === 40) {
							// down arrow
							currActive++;
							highlight(currActive);
						} else if (e.keyCode === 38) {
							// up arrow
							currActive--;
							highlight(currActive);
						} else if (e.keyCode === 13) {
							e.preventDefault();
							e.stopPropagation();
							if ($items && $items.length) {
								navigateToItem($items.eq(currActive));
							}
						} else {
							clearTimeout(pauseTimeout);
							pauseTimeout = setTimeout(doSearch, pauseTime);
						}

					})
					.on('mousedown', 'a', function() {
						navigateToItem($(this));
					})
					.on('blur', 'input', function() {
						$search.removeClass('active has-results');

						if (newDashboardLayout) {
							$resultsContainer.empty();
						}
					})
					.on('mousedown', 'input', function() {
						// Ask for the browsers location if supported, and only once
						if (navigator.geolocation
							&& $locationInput.length == 1
							&& $locationInput.val() == '') {
							navigator.geolocation.getCurrentPosition(function (pos) {
								$locationInput.val(pos.coords.latitude + ', ' + pos.coords.longitude);
							});
						}
					});

				if (newDashboardLayout) {
					$input.on('click', function() {
						$search.addClass('active');
					});
				}
			},


			doSearch = function() {
				if ($input.val().length > minimumSearchCharacters) {

					// Clear results first
					$resultsContainer.empty();

					//Perform search
					$.ajax({
						url: searchUrl + '?name=' + encodeURIComponent($input.val()) + '&location=' + encodeURIComponent($locationInput.val()),
						type: 'GET',
						success: function(html) {
							$search.addClass('active has-results');
							$resultsContainer.append(html);
							$items = $resultsContainer.find('a');
						},
						statusCode: {
							401: function() {
								self.location = '/login';
							}
						}
					});
				}
			},

			highlight = function(_which) {

				if (_which === -1) {
					_which = $items.length - 1;
				}
				if (_which === $items.length) {
					_which = 0;
				}

				currActive = _which;

				$items
					.removeClass('hi')
					.eq(_which)
					.addClass('hi');

			},

			navigateToItem = function($anchor) {
				window.location = $anchor.attr("href");
			};

		init(el);

	};

}(jQuery));


$(document).ready(function() {
	$('.org-search, .org-search-mobile').each(function() {
		new $.search(this);
	});
});
